var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userReady)?_c('RewardsMain'):(_vm.rewardsEnabled)?_c('MissedRewards'):_c('ComingSoon')}
var staticRenderFns = []

export { render, staticRenderFns }